import React, { useEffect, useState } from "react"
import { initializeApp } from "firebase/app"
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore"
import { Helpers } from "@flexday/common-react"
import InventoryCard from "../reusable-components/inventory-card"

const collectionOptions = {
  "Meeting Room": "meetingRoomLocations",
  "Flexday Suite": "privateOfficeLocations",
  "Private Office": "privateOfficeLocations",
}

const StandaloneInventoryCard = ({ id, inventoryType }) => {
  const [location, setLocation] = useState(null)

  const getLocation = async () => {
    const { getFirebaseConfig } = Helpers
    const firebaseConfig = getFirebaseConfig({
      REACT_APP_FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
      REACT_APP_FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
      REACT_APP_FIREBASE_MESSAGE_SENDER_ID:
        process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
      REACT_APP_FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    })
    const app = initializeApp(firebaseConfig)
    const firestore = getFirestore(app)
    const inventoryCollectionRef = collection(
      firestore,
      collectionOptions[inventoryType]
    )
    const querySnapshot = await getDocs(
      query(
        inventoryCollectionRef,
        where("id", "==", id),
        where("isVisible", "==", true)
      )
    )
    querySnapshot.forEach((doc) => {
      setLocation(doc.data())
    })
  }

  useEffect(() => {
    getLocation()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, inventoryType])

  if (!location) {
    return null
  }

  const onSelected = (locationId) => {}

  return (
    <div className="w-72">
      <InventoryCard
        location={location}
        selectedTab={inventoryType}
        onSelected={onSelected}
      />
    </div>
  )
}

export default StandaloneInventoryCard
